import platform from '@propertypal/shared/src/utils/platform';
import PremierListingContent from '@propertypal/web-ui/src/promote/PremierListingContent';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: `Premier Listing - ${platform.title}`,
  description:
    'Make A Property Really Stand Out With An Enhanced Listing That Includes Extra Photos And A Property Description.',
  url: `/products/estate-agents/premier-listing`,
};

const PremierListingPage = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <PremierListingContent products />
    </>
  );
};

export default PremierListingPage;
